import { render, staticRenderFns } from "./GestionEmpleados.vue?vue&type=template&id=2e266581&scoped=true"
import script from "./GestionEmpleados.vue?vue&type=script&lang=js"
export * from "./GestionEmpleados.vue?vue&type=script&lang=js"
import style0 from "./GestionEmpleados.vue?vue&type=style&index=0&id=2e266581&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e266581",
  null
  
)

export default component.exports